import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptBR from './languages/ptBR.json';
import enUS from './languages/enUS.json';
import esES from './languages/esES.json';
import { getCookie } from 'utils/getCookieByName';

const resources = {
  'pt-BR': ptBR,
  'en-US': enUS,
  'es-ES': esES,
};

const { } = JSON.parse(getCookie('language') || '{}');

i18next.use(initReactI18next).init({
  lng: 'pt-BR',
  resources,
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
